import { CALENDAR_VIEWABLE_USERS, CALENDAR_VIEW_CONFIGURATION, CALENDAR_VIEW_CONFIGURATION_ITEM } from './queries';
import { ADD_CALENDAR_VIEW, UPDATE_CALENDAR_VIEW, DELETE_CALENDAR_VIEW, TOGGLE_CALENDAR_VIEW } from './mutations';

export const sharingApi = {
  queries: {
    viewableUsers: CALENDAR_VIEWABLE_USERS,
    configuration: CALENDAR_VIEW_CONFIGURATION,
    configurationItem: CALENDAR_VIEW_CONFIGURATION_ITEM,
  },
  mutations: {
    addView: ADD_CALENDAR_VIEW,
    toggleView: TOGGLE_CALENDAR_VIEW,
    updateView: UPDATE_CALENDAR_VIEW,
    deleteView: DELETE_CALENDAR_VIEW,
  },
};
